"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Price = /** @class */ (function () {
    function Price(fullPrice, deposit, outstanding, deadline) {
        this.fullPrice = fullPrice;
        if (deposit !== undefined) {
            this.deposit = deposit;
        }
        if (outstanding !== undefined) {
            this.outstanding = outstanding;
        }
        this.deadline = deadline;
    }
    return Price;
}());
exports.Price = Price;
//# sourceMappingURL=price.js.map